import {Component, Mixins, Prop} from "vue-property-decorator";
import WebpartTemplate from "@webparts/components/webparts/base/WebpartTemplate.vue";
import WebpartBase from "@webparts/components/webparts/base/WebpartBase";
import { LoadingBar } from "@appbase/components/loading";
import api from '@webparts/api'
import { getLangProperty } from '@appbase/util'

@Component({
    name: 'workflow-count',
    components: {
        WebpartTemplate, LoadingBar
    }
})
export default class WorkflowCountWebpart extends Mixins(WebpartBase) {

    @Prop({ type: Object }) webpart!: webpartv3.Webpart;

    countData: workflow.WorkflowWebpartSetting = {
        draft: {
            processing: 0,
            reject: 0,
            complete: 0,
            temp: 0,
        },
        approval: {
            pending: 0,
            incoming: 0,
            emergency: 0
        }
    };

    load(){
        this.loading = true;

        api.home.getWorkflowCounts().then(result => {
            if(result){
                this.countData = result
                this.loading = false;
            }
        })
    }

    goToWorkflow(){
        const findWorkflow = (menus: appbase.cache.TMenuItem[]): appbase.cache.TMenuItem | null => {
            for (var m of menus) {
                if (m.baseUrl?.toLowerCase().includes("workflow")) return m;
                else if (m.hasChildren) {
                    const sub = findWorkflow(m.children);
                    if (sub) return sub;
                }
            }
            return null;
        };

        var id = findWorkflow(this.portalCache.menu.items);

        if (id) {
            window.location.href = `/workflow/page/home?MENUID=${id.menuId}&SYSID=1&_t=${Date.now()}`;
        } else {
            (window as any).alertAsync(this.$t("관리자에게_문의하세요."));
            return;
        }
    }

    goToDocumentBox(menuId: number, statusFilter?: string){
        let url = `/workflow/page/documentbox?MENUID=${menuId}&_t=${Date.now()}`;
        if (statusFilter) {
            url += `&APMSTATUS=${encodeURIComponent(statusFilter)}`;
        }
        window.location.href = url;
    }

    created(){
        if (!this.preview) {
            this.load();
        }
    }
}